import { render, staticRenderFns } from "./EditOnlineBidding.vue?vue&type=template&id=bb5ee680&scoped=true&"
import script from "./EditOnlineBidding.vue?vue&type=script&lang=js&"
export * from "./EditOnlineBidding.vue?vue&type=script&lang=js&"
import style0 from "./EditOnlineBidding.vue?vue&type=style&index=0&id=bb5ee680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ee680",
  null
  
)

export default component.exports